import { MarkerClusterer } from "@googlemaps/markerclusterer";

const storeLocator = {
	
	ui: {
		storeLocatorSingleMap: null,
		lockAjaxStoreLocator: false,
		timeoutHide: null,
		timeoutAutocomplete: null,
		allShowrooms: null
	},

	init: function() {
		this.bindUI();
		this.bindEvents();
	},

	bindUI: function() {
		this.ui.$storeLocator = $('.js-storeLocator');
		this.ui.$storeLocatorForm = $('.js-storeLocator-form');
		this.ui.$storeLocatorSubmitBtn = $('.js-storeLocator-submit');
		this.ui.$storeLocatorProfileRadio = $('.js-storeLocator-profile');
		this.ui.$geolocInput = $(".js-storeLocator-geoloc-input");
		this.ui.$searchText = $(".js-storeLocator-search-text");

		this.ui.$storeLocatorBack = $('.js-storeLocator__back');

		this.ui.$storeLocatorZoomIn = $('.js-storeLocator-ZoomIn');
		this.ui.$storeLocatorZoomOut = $('.js-storeLocator-ZoomOut');
		this.ui.$storeLocatorMap = $('.js-storeLocator-map');
		
		this.ui.$storeLocatorSingleMap = $('.js-storeLocatorSingle-map');


		this.ui.$geolocResults = $(".js-storeLocator-geoloc-results");
		this.ui.$geolocLoader = $(".js-storeLocator-geoloc-loader")
		this.ui.$storeLocatorGeolocLat = $('.js-storeLocator-geoloc-lat');
		this.ui.$storeLocatorGeolocLng = $('.js-storeLocator-geoloc-lng');
		this.ui.$storeLocatorGeolocTypes = $('.js-storeLocator-geoloc-types');
		this.ui.$getPosition = $(".js-storeLocator-getPosition");
		this.ui.$showroomsList = $(".js-storeLocator-showroomsList");
		this.ui.$showroomsnoResults = $('.js-storeLocator-showrooms-noresults');
		this.ui.$showrooms = $(".js-showrooms");
		this.ui.$filterType = $(".js-storeLocator-filterType");
		this.ui.$filterFamily = $(".js-storeLocator-filterFamily");

		this.ui.$loader = $(".js-storeLocator-loader");
	},

	bindEvents: function() {
		this.ui.$geolocInput.on('keyup', this.geolocInputChange.bind(this));
		this.ui.$geolocInput.on('focusin', this.geolocInputIn.bind(this));
		this.ui.$geolocInput.on('click', (e)=>{e.stopPropagation();});
		this.ui.$geolocResults.on('click', (e)=>{e.stopPropagation();});
		// this.ui.$geolocInput.on('focusout', this.geolocInputOut.bind(this));
		$('body').on('click', this.geolocClosePanel.bind(this));

		this.ui.$getPosition.on('click', this.getUserPosition.bind(this));

		this.ui.$storeLocatorZoomIn.on('click', this.zoomIn.bind(this));
		this.ui.$storeLocatorZoomOut.on('click', this.zoomOut.bind(this));

		this.ui.$storeLocatorProfileRadio.on('change', this.checkErrorForm.bind(this));

		this.ui.$filterType.on('change', this.updateMarkers.bind(this));
		this.ui.$filterFamily.on('change', this.updateMarkers.bind(this));

		this.ui.$storeLocatorForm.on('submit', this.submitForm.bind(this));

		this.ui.$storeLocatorBack.on('click', this.backToStart.bind(this));

		$('body').on('gmapInitStoreLocator', this.initStoreLocatorMap.bind(this));
		if(window.isGmapInitStoreLocator){
			this.initStoreLocatorMap();
		}

		$('body').on('gmapInitSingle', this.initSingle.bind(this));
		if(window.isGmapInitSingle){
			this.initSingle();
		}
	},

	initSingle: function(){
		let showrooms = $(".js-showrooms");

		const lat = parseFloat(showrooms.eq(0).attr("data-lat"));
		const lng = parseFloat(showrooms.eq(0).attr("data-long"));

		this.ui.storeLocatorSingleMap = new google.maps.Map(this.ui.$storeLocatorSingleMap[0], {
    		disableDefaultUI: true, // remove default UI
			mapId: "73d66e66601c8586",
			center: new google.maps.LatLng(lat, lng),
			zoom: 18,
		});
		const marker = new google.maps.Marker({
			position: { lat: lat, lng: lng },
			icon: "/images/pin.svg"
		});
		marker.setMap(this.ui.storeLocatorSingleMap);
	},

	initStoreLocatorMap: function(){
		if(window.isGmapInitStoreLocator){
			window.isGmapInitStoreLocator = false; // pour que l'inistialisation ne se fasse qu'une fois au cas où ya un bad mojo
			this.ui.storeLocatorMap = new google.maps.Map(this.ui.$storeLocatorMap[0], {
				disableDefaultUI: true, // remove default UI
				mapId: "73d66e66601c8586",
				center: new google.maps.LatLng(48.856614, 2.3522219),
				zoom: 13,
			});
			this.ui.storeLocatorMarkers = [];
			this.ui.storeLocatorMarkerClusterer = new MarkerClusterer({ 
				markers: this.ui.storeLocatorMarkers, 
				map: this.ui.storeLocatorMap,
				renderer: {
					render: function ({ count, position }, stats) {
						// use d3-interpolateRgb to interpolate between red and blue
						const color = "#2D2D2D";
						// create svg url with fill color
						const svg = window.btoa(`
							<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
								<circle cx="120" cy="120" opacity="1" r="70" />    
							</svg>
						`);
						// create marker using svg icon
						return new google.maps.Marker({
							position,
							icon: {
								url: `data:image/svg+xml;base64,${svg}`,
								scaledSize: new google.maps.Size(75, 75),
							},
							label: {
								text: String(count),
								color: "rgba(255,255,255,0.9)",
								fontSize: "12px",
							},
							// adjust zIndex to be above other markers
							zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
						});
					}
				}
			});
			this.ui.PlacesService = new google.maps.places.PlacesService(this.ui.storeLocatorMap);
			this.geocoder = new google.maps.Geocoder();

			// // reorder based on the distance of the center of the current position on the map
			// this.ui.storeLocatorMap.addListener("center_changed", () => {
			// 	this.updateMarkers();
			// });

			let profile = this.getCookie("storeLocator_profile");
			this.ui.$storeLocatorProfileRadio.filter("[value='"+profile+"']").prop("checked", true);
			let searchTerm = this.getCookie("storeLocator_search"); 
			this.ui.$geolocInput.val(searchTerm);  
			let storeLocator_lat = this.getCookie("storeLocator_lat");
			this.ui.$storeLocatorGeolocLat.val(storeLocator_lat);
			let storeLocator_lng = this.getCookie("storeLocator_lng");
			this.ui.$storeLocatorGeolocLng.val(storeLocator_lng);
			let storeLocator_type = this.getCookie("storeLocator_type");
			this.ui.$storeLocatorGeolocTypes.val(storeLocator_type);
			if(profile && searchTerm && storeLocator_lat && storeLocator_lng && storeLocator_type){
				// this.goToMap(profile, searchTerm);
				this.ui.storeLocatorMap.setCenter({
					'lat':parseFloat(storeLocator_lat),
					'lng':parseFloat(storeLocator_lng),
				});
				this.ui.$storeLocatorForm.submit();
			}
		}
	},
	zoomIn: function(){
		this.ui.storeLocatorMap.setZoom(this.ui.storeLocatorMap.getZoom()+1);
	},
	zoomOut: function(){
		this.ui.storeLocatorMap.setZoom(this.ui.storeLocatorMap.getZoom()-1);
	},
	checkErrorForm: function($this) {
		let error = false;
		if(this.ui.$storeLocatorProfileRadio.filter(":checked").length < 1){
			error = true;
			this.ui.$storeLocatorProfileRadio.addClass("error")
		}else{
			this.ui.$storeLocatorProfileRadio.removeClass("error")
		}
		if(this.ui.$storeLocatorGeolocLat.val().length == 0){
			error = true;
			this.ui.$geolocInput.addClass("error");
		}
		if(this.ui.$geolocInput.val().length == 0){
			error = true;
			this.ui.$geolocInput.addClass("error");
		}else{
			this.ui.$geolocInput.removeClass("error");
		}
		if(this.ui.$storeLocatorGeolocLng.val().length == 0){
			error = true;
			this.ui.$geolocInput.addClass("error");
		}
		if(this.ui.$storeLocatorGeolocTypes.val().length == 0){
			error = true;
			this.ui.$geolocInput.addClass("error");
		}
		this.ui.$storeLocatorSubmitBtn.prop("disabled", error);
		return error;
	},
	backToStart: function(e){
		this.ui.$storeLocator.removeClass("active");
	},
	submitForm: function(e){
		e.preventDefault();
		if(!this.checkErrorForm()){
			let profile = this.ui.$storeLocatorProfileRadio.filter(":checked").val();
			this.setCookie("storeLocator_profile", this.ui.$storeLocatorProfileRadio.filter(":checked").val());
			let searchTerm = this.ui.$geolocInput.val();
			this.setCookie("storeLocator_search", this.ui.$geolocInput.val());
			this.setCookie("storeLocator_lat", this.ui.$storeLocatorGeolocLat.val());
			this.setCookie("storeLocator_lng", this.ui.$storeLocatorGeolocLng.val());
			this.setCookie("storeLocator_type", this.ui.$storeLocatorGeolocTypes.val());
			this.goToMap(profile, searchTerm);
		}
	},
	getStoreAjax: function(){
		var $form = this.ui.$storeLocatorForm
		,	ajaxTargetUrl = $form.attr("action")
		,	serializedArrayForm = $form.serializeArray();
	
		// generate ajax params from form
			let JSONparams = {}
			for (var i = 0; i < serializedArrayForm.length; i++) {
				if(serializedArrayForm[i].name == "types"){
					JSONparams['country'] = serializedArrayForm[i].value.includes('country') ? 1 : 0;
				}else{
					JSONparams[serializedArrayForm[i].name] = serializedArrayForm[i].value;
				}
			}
	
		// maj URL with form params (for GET form)
			// let newUrl = "?";
			// for (var i = 0; i < serializedArrayForm.length; i++) {
			// 	if(i!=0){
			// 		newUrl += "&";
			// 	}
			// 	newUrl += serializedArrayForm[i].name+"="+serializedArrayForm[i].value;
			// }
			// if(history && history.pushState){//on vérifie si le navigateur supporte la navigation par historique
			// 	history.pushState({page: newUrl}, newUrl, newUrl);//on écrit dans l'historique, on modifie l'url
			// }
	
		this.ui.lockAjaxStoreLocator = true;
		this.ui.$showroomsList.html("")
		this.ui.$loader.addClass('active').removeClass('hide');
	
		if(window.currentajax){// si requete en cours, on l'annule et la remplace par la nouvelle
			window.currentajax.abort();
		}
		// post or get
		window.currentajax = $.get(
			ajaxTargetUrl,
			JSONparams,
			function(response){}
		).done((response) => {
			this.ui.$showroomsList.append($(response.html));
			this.ui.$showrooms =  $(response.html).not(".undefined");
			this.ui.allShowrooms = $(response.showrooms).not(".undefined");
			this.updateMarkers();
		})
		.fail((response) => {
			console.error(response);
		})
		.always((response) => {
			this.ui.$loader.removeClass('active').addClass('hide');
			this.ui.lockAjaxStoreLocator = false;
		});
	},

	goToMap: function(profile, searchTerm){
		this.ui.$searchText.text(searchTerm);
		this.ui.$storeLocator.addClass("active");

		this.getStoreAjax();
		// this.updateMarkers();
	},

	updateMarkers: function(){
		this.ui.storeLocatorMarkerClusterer.clearMarkers();
		this.ui.storeLocatorMarkers = [];
		this.filterTypeAndFamily();
		let $showroomsFiltered = this.ui.$showrooms.not(".js-hide");
		let $allShowrooms = this.ui.allShowrooms.not(".js-hide");
		let center = this.ui.storeLocatorMap.getCenter()
        let bounds = new google.maps.LatLngBounds();

		if ($allShowrooms.length) {
			for (let i = 0; i < $allShowrooms.length; i++) {
				const latlng = {
					lat: parseFloat($allShowrooms.eq(i).attr("data-lat")),
					lng: parseFloat($allShowrooms.eq(i).attr("data-long")),
				};

				const marker = new google.maps.Marker({
					// position: { lat: lat, lng: lng },
					position: latlng,
					icon: "/images/pin.svg"
				});
				marker.setMap(this.ui.storeLocatorMap);
				const infowindow = new google.maps.InfoWindow({
					content: $allShowrooms.eq(i).clone()[0],
				});
				marker.addListener("click", () => {
					infowindow.open({
						anchor: marker,
						map: this.ui.storeLocatorMap,
					});
				});

				this.ui.storeLocatorMarkers.push(marker)
			}
			this.ui.storeLocatorMarkerClusterer.addMarkers(this.ui.storeLocatorMarkers);
		}

        if ($showroomsFiltered.length) {
			bounds.extend({
				lat: parseFloat(this.ui.$storeLocatorGeolocLat.val()),
				lng: parseFloat(this.ui.$storeLocatorGeolocLng.val()),
			});
			for (let i = 0; i < $showroomsFiltered.length; i++) {
	            bounds.extend({
					lat: parseFloat($showroomsFiltered.eq(i).attr("data-lat")),
					lng: parseFloat($showroomsFiltered.eq(i).attr("data-long")),
				});
			}

	      	this.ui.storeLocatorMap.fitBounds(bounds);
			this.ui.$showroomsList.removeClass('hide');
			this.ui.$showroomsnoResults.addClass('hide');
		}else{
			this.ui.$showroomsList.addClass('hide');
			this.ui.$showroomsnoResults.removeClass('hide');
		}
	},

	setCookie: function(name,value,days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			var expires = "; expires="+date.toGMTString();
		}
		else var expires = "";
		document.cookie = name+"="+value+expires+"; path=/";
	},

	getCookie: function(name) {
		var nameEQ = name + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	},

	getUserPosition: function(){
		navigator.geolocation.getCurrentPosition((currentPosition)=>{
			const latlng = {
				lat: parseFloat(currentPosition.coords.latitude),
				lng: parseFloat(currentPosition.coords.longitude),
			};
			this.locationToAddress(latlng);
		});
	},
	locationToAddress: function(latlng){
		this.geocoder.geocode({location: latlng}).then((response) => {
			this.selectPrediction(
				{
					'resultText': response.results[0].formatted_address,
					'lat': response.results[0].geometry.location.lat(),
					'lng': response.results[0].geometry.location.lng(),
					'types': response.results[0].types.join(","),
				}
			);
		});
	},

	geolocInputIn: function(e) {
		e.stopPropagation();
		// clearTimeout(this.ui.timeoutHide);
		this.ui.$geolocResults.addClass("open");
	},
	geolocClosePanel: function(e) {
		this.ui.$geolocResults.removeClass("open");
	},
	// geolocInputOut: function(e) {
	// 	this.ui.timeoutHide = setTimeout(() => {
	// 		this.ui.$geolocResults.removeClass("open");
	// 	}, 1000);
	// },
	geolocInputChange: function(e) {
		this.autocompletePredictions(e.target.value);
		this.checkErrorForm();
	},

	emptySearchForm: function(){
		this.ui.$storeLocatorGeolocLat.val("");
		this.ui.$storeLocatorGeolocLng.val("");
		this.ui.$storeLocatorGeolocTypes.val("");
	},
	selectPrediction: function(geolocArgs){
		this.ui.$geolocInput.val(geolocArgs.resultText);
		this.ui.$storeLocatorGeolocLat.val(geolocArgs.lat);
		this.ui.$storeLocatorGeolocLng.val(geolocArgs.lng);
		this.ui.$storeLocatorGeolocTypes.val(geolocArgs.types);
		this.ui.$geolocResults.removeClass("open");
		this.checkErrorForm();		
	},

	autocompletePredictions: function(val){
		if(this.ui.timeoutAutocomplete){
			this.ui.$geolocLoader.addClass('active').removeClass('hide');
			clearTimeout(this.ui.timeoutAutocomplete);
		}
		this.ui.timeoutAutocomplete = setTimeout(()=> {
			const request = {
				query: val,
				fields: ["ALL"],
				// fields: ["formatted_address", "name", "geometry"],
			};
			this.emptySearchForm()
			this.ui.$geolocResults.addClass("open").find('.js-storeLocator-result-item').remove();
			this.ui.PlacesService.findPlaceFromQuery(
				request,
				(results, status) => {
					this.ui.$geolocLoader.removeClass('active').addClass('hide');
					if (results) {
						for (let i = 0; i < results.length; i++) {
							let resultText = results[i].formatted_address;
							let lat = results[i].geometry.location.lat();
							let lng = results[i].geometry.location.lng();
							let types = results[i].types.join(",");
							let $resultItem = $(
								"<li class='storeLocator__resultItem js-storeLocator-result-item js-storeLocator-result-item'>"+
									"<button type='button' class='storeLocator__resultItemBtn js-storeLocator-select-position' data-lat='"+lat+"' data-lng='"+lng+"' data-types='"+types+"'>"+resultText+"</button>"+
								"</li>"
							)
							this.ui.$geolocResults.append($resultItem);
							$resultItem.on('click', (e) =>{
								this.selectPrediction({
									'resultText': resultText,
									'lat': lat,
									'lng': lng,
									'types': types,
								});
								// // centre sur le résultat sélectionné
								// this.ui.storeLocatorMap.setCenter({
								// 	'lat':lat,
								// 	'lng':lng,
								// });
								// utilise le viewport de la sélection
								this.ui.storeLocatorMap.fitBounds(results[i].geometry.viewport)
								this.ui.$storeLocatorForm.submit();
							});
						}
					}
				}
			);
		},500)
	},
	filterTypeAndFamily: function(){
		let $checkedFamilies = this.ui.$filterFamily.filter(":checked");
		let $checkedTypes = this.ui.$filterType.filter(":checked");
		let $checkedProfile = this.ui.$storeLocatorProfileRadio.filter(":checked");
		this.ui.$showrooms.removeClass("js-hide");
		for (var index = 0; index < this.ui.$showrooms.length; index++) {
			let $thisShowroom = this.ui.$showrooms.eq(index);
			let toHide = false;
			if($checkedFamilies.length > 0){
				let products = $thisShowroom.attr("data-products");
				let hasProduct = 0;
				for (var i = 0; i < $checkedFamilies.length; i++) {
					if(products.indexOf($checkedFamilies.eq(i).val()) != -1){
						hasProduct++;
					}
				}
				if(hasProduct == 0){
					toHide = true;
				}
			}
			if($checkedTypes.length > 0){
				let type = $thisShowroom.attr("data-type");
				let hasType = 0;
				for (var i = 0; i < $checkedTypes.length; i++) {
					if(type.indexOf($checkedTypes.eq(i).val()) != -1){
						hasType++;
					}
				}
				if(hasType == 0){
					toHide = true;
				}
			}
			if($checkedProfile.val() == "particulier"){
				if($thisShowroom.attr("data-particulier") != 1){
					toHide = true;
				}
			}
			if($checkedProfile.val() == "professional"){
				if($thisShowroom.attr("data-professional") != 1){
					toHide = true;
				}
			}
			if(toHide){
				$thisShowroom.addClass("js-hide");
			}
		}

		this.ui.allShowrooms.removeClass("js-hide");
		for (var index = 0; index < this.ui.allShowrooms.length; index++) {
			let $thisShowroom = this.ui.allShowrooms.eq(index);
			let toHide = false;
			if($checkedFamilies.length > 0){
				let products = $thisShowroom.attr("data-products");
				let hasProduct = 0;
				for (var i = 0; i < $checkedFamilies.length; i++) {
					if(products.indexOf($checkedFamilies.eq(i).val()) != -1){
						hasProduct++;
					}
				}
				if(hasProduct == 0){
					toHide = true;
				}
			}
			if($checkedTypes.length > 0){
				let type = $thisShowroom.attr("data-type");
				let hasType = 0;
				for (var i = 0; i < $checkedTypes.length; i++) {
					if(type.indexOf($checkedTypes.eq(i).val()) != -1){
						hasType++;
					}
				}
				if(hasType == 0){
					toHide = true;
				}
			}
			if($checkedProfile.val() == "particulier"){
				if($thisShowroom.attr("data-particulier") != 1){
					toHide = true;
				}
			}
			if($checkedProfile.val() == "professional"){
				if($thisShowroom.attr("data-professional") != 1){
					toHide = true;
				}
			}
			if(toHide){
				$thisShowroom.addClass("js-hide");
			}
		}
	},
};

module.exports = storeLocator;